// assets/src/jsx/components/Home/RecentDatabases.jsx
import React from 'react';
import {NavLink} from 'react-router-dom';
import moment from 'moment-timezone';
import IntlMessages from 'appUtil/IntlMessages';

const linkFor = (db) => (
    db.isDraft ? `/app/database/${db.id}/modify` : `/app/database/${db.id}/dashboard`
);

const RecentDatabases = ({databases}) => (
    <div className="gdb-home-panel gdb-home-recent">
        <div className="gdb-home-panel__label">
            <span><IntlMessages id="home.recent.title"/></span>
            <NavLink to="/app/database/get-list"><IntlMessages id="home.recent.viewAll"/></NavLink>
        </div>
        <div className="gdb-home-recent__list">
            {databases.map((db) => (
                <NavLink className="gdb-home-recent__row" to={linkFor(db)} key={db.id}>
                    <span className="gdb-home-recent__swatch" style={{background: db.colorHex || '#9aa1ab'}}/>
                    <span className="gdb-home-recent__name">
                        <IntlMessages id={`db.${db.code}.code`} defaultMessage={db.name || db.code}/>
                        {db.isDraft && <span className="gdb-home-recent__pill"><IntlMessages id="home.draft"/></span>}
                    </span>
                    <span className="gdb-home-recent__when">
                        <IntlMessages id="home.recent.updated"/>&nbsp;{moment(db.modifiedAt).fromNow()}
                    </span>
                    <i className="far fa-angle-right gdb-home-recent__chev" aria-hidden="true"/>
                </NavLink>
            ))}
        </div>
    </div>
);

export default RecentDatabases;
